import React from "react";
import "./HowItWorks.css";

const steps = [
  {
    number: "01",
    title: "Leave a Request",
    description:
      "Fill out a short form or book a call. Tell us what roles you need and when — we'll take it from there.",
  },
  {
    number: "02",
    title: "We Align on Requirements",
    description:
      "We dive deep into your team, culture, and expectations to build a precise candidate profile.",
  },
  {
    number: "03",
    title: "Receive Pre-Vetted Candidates",
    description:
      "We source, screen, and shortlist candidates — you only see those who truly match your needs.",
  },
  {
    number: "04",
    title: "You Hire the Best",
    description:
      "Interview your top picks, make an offer, and welcome your new team member. We stay in touch to ensure a smooth start.",
  },
];

const HowItWorks: React.FC = () => {
  return (
    <section className="how">
      <div className="how__container">
        <div className="how__header">
          <span className="how__tag">Process</span>
          <h2 className="how__title">
            How We<br />
            <span className="how__title--accent">Work</span>
          </h2>
        </div>
        <div className="how__steps">
          {steps.map((step, i) => (
            <div className="how__step" key={i}>
              <div className="how__step-number">{step.number}</div>
              <div className="how__step-line" />
              <h3 className="how__step-title">{step.title}</h3>
              <p className="how__step-desc">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
